import Close from "@mui/icons-material/Close";
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Stack } from "@mui/material";
import CopyableTypography from "components/Typography/CopyableTypography";

interface CopyableListModalProps {
  open: boolean;
  onClose: () => void;
  items: (string | number)[];
  title: string;
  noneFoundText: string;
}

export function CopyableListModal({
  open,
  onClose,
  items,
  title,
  noneFoundText,
}: CopyableListModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          {title} ({items.length})
        </Typography>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 2.5, pb: 3 }}>
        {items.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 2 }}>
            {noneFoundText}
          </Typography>
        ) : (
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {items.map((code) => (
              <CopyableTypography
                key={code}
                text={String(code)}
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  border: "1px solid",
                  borderColor: "divider",
                }}
              />
            ))}
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}
